import { t } from 'i18next';
import React from 'react'
import { useTranslation } from 'react-i18next';
import CustomImageComponent from './CustomImageComponent';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const SearchNews = (props) => {
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const { data } = props;
    const imageUrl = process.env.REACT_APP_IMAGE_URL;
    const currentLang = i18n.language === "en" ? "" : i18n.language || "";
    return (
        <>
            <div className="recent-news p-3">
                {/* <h4 className="mb-3">Search our news</h4>
                <div className="input-group d-block mb-3">
                    <div className="input-box">
                        <input type="text" placeholder="Search By Area, Compound, Developer" name="search" />
                    </div>
                    <button className="search-submit" type="submit"><i className="fa fa-search"></i></button>
                </div> */}

                <h4 className="mb-3">{t("recent_posts")}</h4>
                {data?.recentBlogs?.length &&
                    data?.recentBlogs?.map((item, index) => (
                        <div className="news-card" key={index}>
                            <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/blogs/${item.slug}`}>
                                <CustomImageComponent src={item.blogThumbnail}
                                    alt={item.blogCategoryName} />
                            </a>
                            <div className="news-card-content">
                                <div className="date">{new Date(item.publishedDate).toLocaleString("default", {
                                    month: "long",
                                }) +
                                    " " +
                                    new Date(item.publishedDate).getDate() +
                                    ", " +
                                    new Date(item.publishedDate).getFullYear()}</div>
                                <div className="title">
                                    <a className="text-black" href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/blogs/${item.slug}`}>
                                        {item.title}
                                    </a></div>
                            </div>
                        </div>
                    ))}



                <h4 className="mb-3">{t("tags")}</h4>
                <div className="list-tag">
                    {data?.categories?.length &&
                        data?.categories?.map((item, index) => (
                            <span className="bg-white p-2 me-2" key={index}>{item.name}</span>
                        ))}
                </div>
            </div>
        </>
    )
}

export default SearchNews